import { render, staticRenderFns } from "./ele-cons.vue?vue&type=template&id=3b62b243&scoped=true&"
import script from "./ele-cons.vue?vue&type=script&lang=js&"
export * from "./ele-cons.vue?vue&type=script&lang=js&"
import style0 from "./ele-cons.vue?vue&type=style&index=0&id=3b62b243&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b62b243",
  null
  
)

export default component.exports